import { render, staticRenderFns } from "./AssessmentOverviewSlidebar.vue?vue&type=template&id=63d05492"
import script from "./AssessmentOverviewSlidebar.vue?vue&type=script&lang=js"
export * from "./AssessmentOverviewSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports